import { useEffect } from 'react';

import {
  useSendbirdStateContext,
  sendbirdSelectors,
} from '@sendbird/uikit-react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from 'src/app/store';

import { useAuth } from '../auth/useAuth';
import { setUnreadMessageCount } from './chat.slice';

const useUnreadMessageCount = () => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const globalStore = useSendbirdStateContext();
  const sdkInstance = sendbirdSelectors.getSdk(globalStore);
  const { sendbirdAccessToken } = useAppSelector((state) => state.chat);

  useEffect(() => {
    const fetchUnreadMessageCount = async () => {
      if (
        auth.currentMembership?.id &&
        auth.sendbirdAppId &&
        sendbirdAccessToken &&
        sdkInstance?.connect &&
        sdkInstance?.groupChannel?.getTotalUnreadMessageCount
      ) {
        await sdkInstance.connect(
          auth.currentMembership.id,
          sendbirdAccessToken
        );
        const messageCount =
          await sdkInstance.groupChannel.getTotalUnreadMessageCount();
        dispatch(setUnreadMessageCount(messageCount));
      }
    };

    fetchUnreadMessageCount();

    // This is a hack to get around the fact that the SendbirdApp component
    // removes all userEvent and connection handlers when it unmounts
    // even though the ChatDialog component never unmounts when hidden.
    // This also re-initializes the event handlers. So, the user will at most
    // wait 30 seconds. The majority of messages will be instant.
    const intervalId = setInterval(fetchUnreadMessageCount, 30000);
    return () => clearInterval(intervalId);
  }, [
    auth,
    auth.currentMembership?.id,
    auth.sendbirdAppId,
    dispatch,
    sdkInstance,
    sendbirdAccessToken,
  ]);
};

export default useUnreadMessageCount;
